import { useWrongNetwork } from '@/domain/hooks/useWrongNetwork'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'
import { useEffect } from 'react'
import { Address } from 'viem'
import { ETransferDialogContentContainer } from './ETransferDialogContentContainer'

export interface ETransferDialogProps extends CommonDialogProps {
  vaultAddress: Address
  vaultSymbol: string
  vaultDecimals: number
  underlyingAsset: Address
  assetSymbol: string
  assetDecimals: number
  logoURI?: string
  priceUSD: number
  currentBalance: number
  sourceSubAccountId: number
}

function ETransferDialog({
  open,
  setOpen,
  vaultAddress,
  underlyingAsset,
  assetSymbol,
  assetDecimals,
  logoURI,
  priceUSD,
  currentBalance,
  sourceSubAccountId,
}: ETransferDialogProps) {
  const isWrongNetwork = useWrongNetwork()

  useEffect(() => {
    if (isWrongNetwork && open) {
      setOpen(false)
    }
  }, [isWrongNetwork, open, setOpen])

  if (isWrongNetwork) {
    return null
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent aria-describedby={undefined}>
        <ETransferDialogContentContainer
          closeDialog={() => setOpen(false)}
          vaultAddress={vaultAddress}
          underlyingAsset={underlyingAsset}
          assetSymbol={assetSymbol}
          assetDecimals={assetDecimals}
          logoURI={logoURI}
          priceUSD={priceUSD}
          currentBalance={currentBalance}
          sourceSubAccountId={sourceSubAccountId}
        />
      </DialogContent>
    </Dialog>
  )
}

export const eTransferDialogConfig: DialogConfig<ETransferDialogProps> = {
  options: {
    closeOnChainChange: true,
  },
  element: ETransferDialog,
}
